import React, { useCallback, useState } from "react";
import { Card, Icon, Statistic } from "antd";
import StatisticPeriod from "./StatisticsPeriod";
import { getClientStatistics } from "../../service/clients";

export default function UserStatistics() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const onChange = useCallback(async (range) => {
    // setLoading(true);
    const data = await getClientStatistics({ range, count: true });
    setData({ total: data.total, range: data.range.toString() })
    // setLoading(false);
  }, []);
  return (
    <Card>
      <Statistic
        title={<span>Users <StatisticPeriod onChange={onChange}/></span>}
        value={data.total}
        prefix={<Icon type="user"/>}
        suffix={<span className="color-grey">{data.range}</span>}
      />
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/UserStatistics.js